import styles from './LoginForm.module.scss';
import LoginMenu from "../../../components/login-menu/LoginMenu";
import BasicInformation from "../../../components/basic-information/BasicInformation";
import LoginFormInside from "./LoginFormInside";

const LoginFormComponent = (props: any) => {
    return (
        <div className={styles.container}>
            <div className={styles.menu}>
                <LoginMenu />
            </div>
             <LoginFormInside redirectTo={props.redirectUrl}></LoginFormInside>
            <div className={styles.basic_information}>
                <BasicInformation />
            </div>
        </div>
    )
}

export default LoginFormComponent;

